import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { SprintfulRecordsService } from 'src/app/shared/service/sprintful/sprintful-records.service';
import { AgendaSigningApiService } from 'src/app/core/service/apis/sprintful/agenda-signing-api.service';
import { AgendaSigning } from '../../domain/models/agenda-signing.model';
import { AgendaSigningRepository } from '../../domain/repository/agenda-signing.repository';
import { AgendaSigningMapperService } from '../mappers/agenda-signing-mapper.service';

@Injectable()
export class HttpAgendaSigningRepository implements AgendaSigningRepository {
  constructor(
    private readonly sprintfulRecords: SprintfulRecordsService,
    private readonly mapper: AgendaSigningMapperService,
    private readonly agendaApi: AgendaSigningApiService,
  ) { }

  getAllByRecordIds(recordIds: string[]): Observable<AgendaSigning[]> {
    return this.sprintfulRecords.fetchByRecordIds(recordIds).pipe(
      map(records => records.map(item => this.mapper.toAgendaSigning(item))),
    );
  }

  getReservationDates(recordIds: string[]): Observable<{ reservedDate: string }[]> {
    return this.sprintfulRecords.fetchByRecordIds(recordIds).pipe(
      map(records => records.map(item => ({ reservedDate: item.fechaReservada || '' }))),
    );
  }

  createReservation(payload: any): Observable<any> {
    return this.agendaApi.createReservation(payload);
  }

  cancelReservation(reservationId: string): Observable<any> {
    return this.agendaApi.cancelReservation(reservationId);
  }

  rescheduleReservation(reservationId: string, newDate: string): Observable<any> {
    return this.agendaApi.rescheduleReservation(reservationId, newDate);
  }
}
